export default "__VITE_ASSET__618db862__"